import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import isNil from 'utils/isNil';
import ModalMarketingForm from 'components/ModalMarketingForm';
import Button from 'components/Button';
import SubscribeForm from 'components/Form/SubscribeForm';
import Text from 'components/Text';

const InlineCta = props => {
  const {
    dataPosition,
    formType,
    subHead,
    title,
    colorScheme,
    buttonTitle,
    buttonLinkTo,
    utm,
    useModalForm,
    modalForm,
    ...otherProps
  } = props;
  const [search, setSearch] = useState(undefined);
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  useEffect(() => {
    setSearch(window?.location?.search);
  }, []);

  return (
    <SectionTryDemo
      backgroundColor={colorScheme?.includes('Blue') ? '#009DE6' : '#12889D'}
      titleColor="white"
      {...otherProps}
    >
      <div className="section-try-demo--container">
        <div className="section-try-demo--text-container">
          {!isNil(subHead) && <p className="section-try-demo--small-title">{subHead}</p>}
          <Text type="p" size="h2" className="section-try-demo--title">
            {title}
          </Text>
        </div>

        {(useModalForm || buttonLinkTo) && (
          <div className="section-try-demo--button-container">
            <Button
              dataPosition="Body Conversion Panel - Split CTA"
              type={colorScheme?.includes('White') ? 'white' : 'primary'}
              shadow={false}
              {...(buttonLinkTo ? { to: `${buttonLinkTo}${utm && search ? search : ''}` } : {})}
              {...(useModalForm ? { onClick: () => toggleIsModalOpen(true) } : {})}
            >
              {buttonTitle}
            </Button>
          </div>
        )}
        {!useModalForm && modalForm && (
          <FormContainer>
            <SubscribeForm
              dataPosition={dataPosition}
              marketoForm={modalForm.marketoForm}
              buttonLabel={buttonTitle}
              buttonType="primary"
              notificationMessage={modalForm.thankyou || 'Thanks for subscribing!'}
              notificationSnack={modalForm.thankyouSnackbar}
              shouldRedirect={false}
              shadow={false}
              label=""
            />
          </FormContainer>
        )}
      </div>
      {useModalForm && (
        <ModalMarketingForm
          dataPosition={dataPosition}
          formType={formType}
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          marketingForm={modalForm}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      )}
    </SectionTryDemo>
  );
};

InlineCta.propTypes = {
  subHead: PropTypes.string,
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

export default InlineCta;

const SectionTryDemo = styled.div`
  background: ${props => props.backgroundColor};
  padding: 82px 40px;

  .section-try-demo--container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1200px;
    padding: 0 20px;
    margin: 0 auto;

    .section-try-demo--text-container {
      max-width: 784px;

      .section-try-demo--small-title {
        font-size: 16px;
        font-weight: 900;
        line-height: 110%;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: var(--blue-3);
      }

      .section-try-demo--title {
        font-size: 49px;
        line-height: 110%;
        letter-spacing: -0.04em;
        color: ${props => props.titleColor};
        margin-bottom: 0;
      }
    }

    .section-try-demo--button-container {
      min-width: 160px;
      text-align: right;
    }
  }

  @media (max-width: 991px) {
    .section-try-demo--container {
      .section-try-demo--text-container {
        max-width: 100%;
        padding-right: 50px;

        .section-try-demo--small-title {
          font-size: 15px;
          line-height: 20px;
        }

        .section-try-demo--title {
          font-size: 36px;
          line-height: 44px;
        }
      }

      .section-try-demo--button-container {
        button {
          font-size: 15px;
          padding: 12px 20px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    padding: 52px 20px;

    .section-try-demo--container {
      flex-direction: column;

      .section-try-demo--text-container {
        max-width: 100%;
        text-align: center;
        padding: 0;

        .section-try-demo--title {
          font-size: 32px;
          line-height: 36px;
        }
      }

      .section-try-demo--button-container {
        min-width: 0;
        margin-top: 40px;

        button {
          font-size: 15px;
          padding: 8px 20px;
        }
      }
    }
  }
`;

const FormContainer = styled.div`
  width: 45%;
  background-color: transparent;
  > div {
    color: white;
    padding-top: 0;
  }
  .section-hero--notification {
    color: white;
  }
  @media (max-width: 768px) {
    width: 100%;
    > div {
      padding: 0;
    }
    margin-top: 30px;
  }
`;
